function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  role: "img"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "a",
  width: 20,
  height: 20,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h20v20H0z"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#292A2B",
  d: "M4.5 18q-.618 0-1.06-.448A1.45 1.45 0 0 1 3 16.5v-11q0-.604.44-1.052A1.43 1.43 0 0 1 4.5 4H6V2.75q0-.318.214-.534A.72.72 0 0 1 6.746 2q.316 0 .535.216a.72.72 0 0 1 .219.534V4h5V2.75q0-.318.214-.534A.72.72 0 0 1 13.246 2q.316 0 .535.216A.72.72 0 0 1 14 2.75V4h1.5q.619 0 1.06.448.44.449.44 1.052v11q0 .604-.44 1.052A1.43 1.43 0 0 1 15.5 18zm0-1.5h11V9h-11zm0-9h11v-2h-11zm5.504 4.5a.74.74 0 0 1-.535-.214.71.71 0 0 1-.219-.532q0-.316.214-.535a.71.71 0 0 1 .532-.219q.316 0 .535.214t.219.532-.214.535a.71.71 0 0 1-.532.219m-3.25 0a.74.74 0 0 1-.535-.214.71.71 0 0 1-.219-.532q0-.316.214-.535a.71.71 0 0 1 .532-.219q.316 0 .535.214t.219.532-.214.535a.71.71 0 0 1-.532.219m6.5 0a.74.74 0 0 1-.535-.214.71.71 0 0 1-.219-.532q0-.316.214-.535a.71.71 0 0 1 .532-.219q.316 0 .535.214t.219.532-.214.535a.71.71 0 0 1-.532.219m-3.25 3a.74.74 0 0 1-.535-.214.71.71 0 0 1-.219-.532q0-.316.214-.535a.71.71 0 0 1 .532-.219q.316 0 .535.214t.219.532-.214.535a.71.71 0 0 1-.532.219m-3.25 0a.74.74 0 0 1-.535-.214.71.71 0 0 1-.219-.532q0-.316.214-.535a.71.71 0 0 1 .532-.219q.316 0 .535.214t.219.532-.214.535a.71.71 0 0 1-.532.219m6.5 0a.74.74 0 0 1-.535-.214.71.71 0 0 1-.219-.532q0-.316.214-.535a.71.71 0 0 1 .532-.219q.316 0 .535.214t.219.532-.214.535a.71.71 0 0 1-.532.219"
})));
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/ic-calendar-month.svg";
export { SvgComponent as ReactComponent };